import { takeLatest, put, call, takeEvery, select } from 'redux-saga/effects';
import { LOADER_CLOSE, LOADER_OPEN } from '../actions';
import {
  COURSE_CREATED_LIST_GET,
  COURSE_ACTIVITIES_GET,
  COURSE_STATS_GET,
  COURSE_USERS_GET,
  COURSE_USERS_ACTIVITIES_GET,
  GROUP_COURSES_GET,
  STATS_GROUP_LIST_GET,
  MULTI_PRINT_MY_COURSES,
  MULTI_PRINT_MY_USERS,
  MY_COURSES_GET,
  MY_USERS_GET,
  STATS_USER_LIST,
  USER_COURSES_GET,
  USER_GROUPS_GET,
  USER_STATS_GET,
  SURVEY_STATS_GET,
  SURVEY_FREE_TEXT_ANSWERS_GET,
  MULTI_PRINT_MY_CHARTS_CSV,
  PRINT_MY_TUTORS,
  PRINT_MY_CATEGORIES,
  MULTI_PRINT_MY_ACTIVITIES,
  EVENT_SESSIONS_GET,
  EVENT_USERS_GET,
  EVENT_USERS_ACTIVITIES_GET,
  PRINT_MY_TUTORS_CSV,
  PRINT_ACCESS_CSV,
  PRINT_CATEGORIES_CSV,
  PRINT_ACTIVITIES_CSV,
  PRINT_COURSES_CSV,
} from '../actions/statistics';
import statistics from '../../api/statistics';
import tutors from '../../api/tutors';
import { errorHandling } from '../../../utils/errors';

function* userListGet({ filters, saveIn = 'users' }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response, pager } = {} } = yield call(
      statistics.getUserList,
      filters
    );
    yield put({
      type: STATS_USER_LIST._SUCCESS,
      response,
      pager,
      saveIn,
      filters,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > userListGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* userListGetWatch() {
  yield takeEvery(STATS_USER_LIST._REQUEST, userListGet);
}

function* userStatsGet({ user_id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      statistics.userStatsGet,
      user_id
    );
    yield put({ type: USER_STATS_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > userStatsGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* userStatsGetWatch() {
  yield takeLatest(USER_STATS_GET._REQUEST, userStatsGet);
}

function* userCoursesGet({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response, pager } = {} } = yield call(
      statistics.getUserCourses,
      filters
    );
    yield put({ type: USER_COURSES_GET._SUCCESS, response, pager });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > userCoursesGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* userCoursesGetWatch() {
  yield takeLatest(USER_COURSES_GET._REQUEST, userCoursesGet);
}

function* userGroupsGet({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response, pager } = {} } = yield call(
      statistics.getUserGroups,
      filters
    );
    yield put({ type: USER_GROUPS_GET._SUCCESS, response, pager });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > userGroupsGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* userGroupsGetWatch() {
  yield takeLatest(USER_GROUPS_GET._REQUEST, userGroupsGet);
}

function* courseStatsGet({ course_id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      statistics.getCourseStats,
      course_id
    );
    yield put({ type: COURSE_STATS_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > courseStatsGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* courseStatsGetWatch() {
  yield takeLatest(COURSE_STATS_GET._REQUEST, courseStatsGet);
}

function* courseCreatedListGet({ filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { isSupervisor } = yield select((state) => state.user);
    const { data: { data: response, pager } = {} } = yield call(
      statistics.getCourseCreatedList,
      filters
    );
    yield put({
      type: COURSE_CREATED_LIST_GET._SUCCESS,
      response,
      pager,
      filters,
      isSupervisor,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > courseCreatedListGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* courseCreatedListGetWatch() {
  yield takeEvery(COURSE_CREATED_LIST_GET._REQUEST, courseCreatedListGet);
}

function* courseActivitiesGet({ filters, course_id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      statistics.getCourseActivities,
      course_id,
      filters
    );
    yield put({ type: COURSE_ACTIVITIES_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > courseActivitiesGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* courseActivitiesGetWatch() {
  yield takeLatest(COURSE_ACTIVITIES_GET._REQUEST, courseActivitiesGet);
}

function* eventSessionsGet({ filters, course_id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      statistics.eventSessionsGet,
      course_id,
      filters
    );
    yield put({ type: EVENT_SESSIONS_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > eventSessionsGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* eventSessionsGetWatch() {
  yield takeLatest(EVENT_SESSIONS_GET._REQUEST, eventSessionsGet);
}

function* courseUsersGet({ filters, course_id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response, pager } = {} } = yield call(
      statistics.getCourseUsers,
      course_id,
      filters
    );
    yield put({ type: COURSE_USERS_GET._SUCCESS, response, pager, filters });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > courseUsersGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* courseUsersGetWatch() {
  yield takeLatest(COURSE_USERS_GET._REQUEST, courseUsersGet);
}

function* eventUsersGet({ filters, course_id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response, pager } = {} } = yield call(
      statistics.eventUsersGet,
      course_id,
      filters
    );
    yield put({ type: EVENT_USERS_GET._SUCCESS, response, pager, filters });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > eventUsersGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* eventUsersGetWatch() {
  yield takeLatest(EVENT_USERS_GET._REQUEST, eventUsersGet);
}

function* courseUsersActivitiesGet({ course_id, user_id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      statistics.getCourseUsersActivities,
      course_id,
      user_id
    );
    yield put({ type: COURSE_USERS_ACTIVITIES_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > courseUsersActivitiesGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* courseUsersActivitiesGetWatch() {
  yield takeLatest(
    COURSE_USERS_ACTIVITIES_GET._REQUEST,
    courseUsersActivitiesGet
  );
}

function* eventUsersActivitiesGet({ course_id, user_id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      statistics.eventUsersGet,
      course_id,
      { user_id }
    );
    yield put({ type: EVENT_USERS_ACTIVITIES_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > eventUsersActivitiesGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* eventUsersActivitiesGetWatch() {
  yield takeLatest(
    EVENT_USERS_ACTIVITIES_GET._REQUEST,
    eventUsersActivitiesGet
  );
}

function* groupListGet({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      tutors.groupListGet,
      filters
    );
    yield put({ type: STATS_GROUP_LIST_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > groupListGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* groupListGetWatch() {
  yield takeLatest(STATS_GROUP_LIST_GET._REQUEST, groupListGet);
}

function* myCoursesGet({ year }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      statistics.getMyCourses,
      year
    );
    yield put({ type: MY_COURSES_GET._SUCCESS, response, year });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > myCoursesGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* myCoursesGetWatch() {
  yield takeLatest(MY_COURSES_GET._REQUEST, myCoursesGet);
}

function* groupCoursesGet({ filters, group_id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      statistics.groupCoursesGet,
      group_id,
      filters
    );
    yield put({ type: GROUP_COURSES_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > groupCoursesGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* groupCoursesGetWatch() {
  yield takeLatest(GROUP_COURSES_GET._REQUEST, groupCoursesGet);
}

function* multiPrintMyChatsCSV({
  completion_status_array,
  filters = [],
  start_date,
  end_date,
  key,
}) {
  try {
    yield put({ type: LOADER_OPEN });
    let err;
    // cycle for each course
    for (const filter of filters) {
      // cycle for each type
      for (const completion_status of completion_status_array) {
        err = yield call(statistics.csvChartExport, {
          filter,
          completion_status,
          start_date,
          end_date,
        });
      }
    }
    if (err?.message) throw Error(err);
    else {
      yield put({
        type: MULTI_PRINT_MY_CHARTS_CSV._SUCCESS,
        key,
      });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > multiPrintMyChatsCSV', err);
    yield put({ type: MULTI_PRINT_MY_CHARTS_CSV._ERROR, key });
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* multiPrintMyChatsCSVWatch() {
  yield takeLatest(MULTI_PRINT_MY_CHARTS_CSV._REQUEST, multiPrintMyChatsCSV);
}

function* printAccessCSV({ filters, key }) {
  try {
    yield put({ type: LOADER_OPEN });
    const err = yield call(statistics.csvAccessExport, filters);
    if (err?.message) throw Error(err);
    else {
      yield put({
        type: PRINT_ACCESS_CSV._SUCCESS,
        key,
      });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > printAccessCSV', err);
    yield put({ type: PRINT_ACCESS_CSV._ERROR, key });
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* printAccessCSVWatch() {
  yield takeLatest(PRINT_ACCESS_CSV._REQUEST, printAccessCSV);
}

function* printMyTutorsCSV({ key }) {
  try {
    yield put({ type: LOADER_OPEN });
    const err = yield call(statistics.csvMyTutorExport);
    if (err?.message) throw Error(err);
    else {
      yield put({
        type: PRINT_MY_TUTORS_CSV._SUCCESS,
        key,
      });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > printMyTutorsCSV', err);
    yield put({ type: PRINT_MY_TUTORS_CSV._ERROR, key });
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* printMyTutorsCSVWatch() {
  yield takeLatest(PRINT_MY_TUTORS_CSV._REQUEST, printMyTutorsCSV);
}

function* printCategoriesCSV({ filters, key }) {
  try {
    yield put({ type: LOADER_OPEN });
    const err = yield call(statistics.csvCategoriesExport, filters);
    if (err?.message) throw Error(err);
    else {
      yield put({
        type: PRINT_CATEGORIES_CSV._SUCCESS,
        key,
      });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > printCategoriesCSV', err);
    yield put({ type: PRINT_CATEGORIES_CSV._ERROR, key });
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* printCategoriesCSVWatch() {
  yield takeLatest(PRINT_CATEGORIES_CSV._REQUEST, printCategoriesCSV);
}

function* multiPrintCoursesCSV({ type_array, start_date, end_date, key }) {
  try {
    yield put({ type: LOADER_OPEN });
    let err;
    // cycle for each type
    for (const filter of type_array) {
      err = yield call(statistics.csvCoursesExport, {
        filter,
        start_date,
        end_date,
      });
    }
    if (err?.message) throw Error(err);
    else {
      yield put({
        type: PRINT_COURSES_CSV._SUCCESS,
        key,
      });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > multiPrintCoursesCSV', err);
    yield put({ type: PRINT_COURSES_CSV._ERROR, key });
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* multiPrintCoursesCSVWatch() {
  yield takeLatest(PRINT_COURSES_CSV._REQUEST, multiPrintCoursesCSV);
}

function* printActivitiesCSV({ filters, key }) {
  try {
    yield put({ type: LOADER_OPEN });
    const err = yield call(statistics.csvActivitiesExport, filters);
    if (err?.message) throw Error(err);
    else {
      yield put({
        type: PRINT_ACTIVITIES_CSV._SUCCESS,
        key,
      });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > printActivitiesCSV', err);
    yield put({ type: PRINT_ACTIVITIES_CSV._ERROR, key });
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* printActivitiesCSVWatch() {
  yield takeLatest(PRINT_ACTIVITIES_CSV._REQUEST, printActivitiesCSV);
}

//* others
function* multiPrintMyCourses({ export_types, course_ids, courses = [] }) {
  try {
    yield put({ type: LOADER_OPEN });
    let err;
    // cycle for each course
    for (const course_id of course_ids) {
      // cycle for each type
      for (const export_type of export_types) {
        const course = courses.find((c) => c?.id === course_id);
        err = yield call(
          statistics.courseExport,
          { course_id, export_type },
          course?.title
        );
      }
    }
    if (err?.message) throw Error(err);
    else {
      yield put({ type: MULTI_PRINT_MY_COURSES._SUCCESS, key: 'courses' });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > multiPrintMyCourses', err);
    yield put({ type: MULTI_PRINT_MY_COURSES._ERROR, key: 'courses' });
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* multiPrintMyCoursesWatch() {
  yield takeLatest(MULTI_PRINT_MY_COURSES._REQUEST, multiPrintMyCourses);
}

const getCompletionStatus = (key) => {
  if (key === 'assignments') return undefined;
  if (key === 'fruitions') return 'incomplete';
  return 'completed';
};
function* myUsersGet({ filters, status_array }) {
  try {
    yield put({ type: LOADER_OPEN });
    const response = {};
    for (const key of status_array) {
      const { data: { data } = {} } = yield call(
        statistics.getMyUsers,
        filters,
        getCompletionStatus(key)
      );
      response[key] = data;
    }
    yield put({ type: MY_USERS_GET._SUCCESS, response, filters });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > myUsersGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* myUsersGetWatch() {
  yield takeEvery(MY_USERS_GET._REQUEST, myUsersGet);
}

function* multiPrintMyUsers({ export_types = [], filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    let err;
    // cycle for each type
    for (const export_type of export_types) {
      err = yield call(statistics.usersExport, { export_type, ...filters });
    }
    if (err?.message) throw Error(err);
    else {
      yield put({ type: MULTI_PRINT_MY_USERS._SUCCESS, key: 'users' });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > multiPrintMyUsers', err);
    yield put({ type: MULTI_PRINT_MY_USERS._ERROR, key: 'users' });
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* multiPrintMyUsersWatch() {
  yield takeLatest(MULTI_PRINT_MY_USERS._REQUEST, multiPrintMyUsers);
}

function* printMyTutors({ filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    const err = yield call(statistics.tutorsExport, filters);
    if (err?.message) throw Error(err);
    else {
      yield put({ type: PRINT_MY_TUTORS._SUCCESS, key: 'tutors' });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > printMyTutors', err);
    yield put({ type: PRINT_MY_TUTORS._ERROR, key: 'tutors' });
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* printMyTutorsWatch() {
  yield takeLatest(PRINT_MY_TUTORS._REQUEST, printMyTutors);
}

function* printMyCategories({ filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    const err = yield call(statistics.categoriesExport, filters);
    if (err?.message) throw Error(err);
    else {
      yield put({ type: PRINT_MY_CATEGORIES._SUCCESS, key: 'categories' });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > printMyCategories', err);
    yield put({ type: PRINT_MY_CATEGORIES._ERROR, key: 'categories' });
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* printMyCategoriesWatch() {
  yield takeLatest(PRINT_MY_CATEGORIES._REQUEST, printMyCategories);
}

function* multiPrintMyActivities({ export_types = [], filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    // cycle for each type
    let err;
    for (const export_type of export_types) {
      err = yield call(statistics.activitiesExport, {
        export_type,
        ...filters,
      });
    }
    if (err?.message) throw Error(err);
    else {
      yield put({
        type: MULTI_PRINT_MY_ACTIVITIES._SUCCESS,
        key: 'activities',
      });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > multiPrintMyActivities', err);
    yield put({ type: MULTI_PRINT_MY_ACTIVITIES._ERROR, key: 'activities' });
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* multiPrintMyActivitiesWatch() {
  yield takeLatest(MULTI_PRINT_MY_ACTIVITIES._REQUEST, multiPrintMyActivities);
}

function* surveyStatsGet({ id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      statistics.surveyStatsGet,
      id
    );
    if (response) {
      yield put({ type: SURVEY_STATS_GET._SUCCESS, response });
      for (const questionId of response?.free_text_ids || []) {
        const { data: { data: answers, pager } = {} } = yield call(
          statistics.surveyFreeTextAnswersGet,
          id,
          {
            paragraph_id: questionId,
            items_per_page: 6,
          }
        );
        yield put({
          type: SURVEY_FREE_TEXT_ANSWERS_GET._SUCCESS,
          questionId,
          answers,
          pager,
        });
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > surveyStatsGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* surveyStatsGetWatch() {
  yield takeLatest(SURVEY_STATS_GET._REQUEST, surveyStatsGet);
}

function* surveyFreeTextAnswersGet({ courseId, questionId, page = 0 }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      statistics.surveyFreeTextAnswersGet,
      courseId,
      {
        paragraph_id: questionId,
        items_per_page: 6,
        page,
      }
    );
    yield put({ type: SURVEY_FREE_TEXT_ANSWERS_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > user > surveyFreeTextAnswersGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* surveyFreeTextAnswersGetWatch() {
  yield takeLatest(
    SURVEY_FREE_TEXT_ANSWERS_GET._REQUEST,
    surveyFreeTextAnswersGet
  );
}

export default [
  userListGetWatch(),
  userStatsGetWatch(),
  userCoursesGetWatch(),
  userGroupsGetWatch(),
  courseStatsGetWatch(),
  courseCreatedListGetWatch(),
  courseActivitiesGetWatch(),
  eventSessionsGetWatch(),
  courseUsersGetWatch(),
  eventUsersGetWatch(),
  courseUsersActivitiesGetWatch(),
  eventUsersActivitiesGetWatch(),
  groupListGetWatch(),
  groupCoursesGetWatch(),
  myCoursesGetWatch(),
  //*csv
  multiPrintMyChatsCSVWatch(),
  printAccessCSVWatch(),
  printMyTutorsCSVWatch(),
  printCategoriesCSVWatch(),
  multiPrintCoursesCSVWatch(),
  printActivitiesCSVWatch(),
  //others
  multiPrintMyCoursesWatch(),
  myUsersGetWatch(),
  multiPrintMyUsersWatch(),
  surveyStatsGetWatch(),
  surveyFreeTextAnswersGetWatch(),
  printMyTutorsWatch(),
  printMyCategoriesWatch(),
  multiPrintMyActivitiesWatch(),
];
